import OrganizationList from '@/components/organization/OrganizationList'

const OrganizationsPage = () => {
  return <OrganizationList />
}

export default OrganizationsPage